import { getCacheUrlParamValue } from "../utils/api-calls";

export class TrvCryptoService {
  private static readonly HOST = `${
    process.env.NODE_ENV === "development" ? "http://localhost:3000" : ""
  }/_api`;

  static async getStatistics(code: string): Promise<CryptoStatistics> {
    const response = await fetch(
      `${
        TrvCryptoService.HOST
      }/currencies/${code}/statistics?cache=${getCacheUrlParamValue()}`
    );

    return response.json();
  }

  static async getCrypoPrice(
    pointer = 0,
    limit?: number
  ): Promise<CryptoPriceData[]> {
    const limitParam = limit ? `&pointer=${pointer}&limit=${limit}` : "";
    const response = await fetch(
      `${
        TrvCryptoService.HOST
      }/currencies/prices?cache=${getCacheUrlParamValue()}${limitParam}`
    );
    return response.json();
  }

  static async getTicker(): Promise<TickerItem[]> {
    const response = await fetch(
      `${TrvCryptoService.HOST}/ticker?cache=${getCacheUrlParamValue()}`
    );
    return response.json();
  }
}
